<div class="client-materials-container w-full">
  <app-smart-grid
    [data]="materialData?.materials || []"
    [columnDefs]="materialSummaryColumnDefs"
    [config]="materialSummaryGridConfig"
    [loading]="isLoading">
  </app-smart-grid>

</div>
